/** Tipi e costanti condivisi tra i componenti warehouse. */

export type Category = 'Abbigliamento' | 'DpiIndividuale' | 'AttrezziHoldable' | 'Consumabili' | 'Altro';

export const CATEGORIES: Category[] = ['Abbigliamento', 'DpiIndividuale', 'AttrezziHoldable', 'Consumabili', 'Altro'];

export const CATEGORY_LABEL: Record<Category, { icon: string; label: string }> = {
  Abbigliamento:    { icon: '👕', label: 'Abbigliamento' },
  DpiIndividuale:   { icon: '🦺', label: 'DPI' },
  AttrezziHoldable: { icon: '🔧', label: 'Attrezzi' },
  Consumabili:      { icon: '📦', label: 'Consumabili' },
  Altro:            { icon: '📌', label: 'Altro' },
};

export interface Item {
  id: string;
  category: Category;
  name: string;
  quantity: number;
  unit?: string;
  serialNumber?: string;
  expiry?: string;
  notes?: string;
}
